
import Vue from 'vue';
import Component from 'vue-class-component';
import { BoListPanel } from 'bonomo/dist';
import { namespace } from 'vuex-class';
import { ILockerCompanyLog} from '@/model/logs/Ilogs';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";

const lockerCompanyModule = namespace('lockerCompanyModule');

@Component({
  name: 'WebhookLogs',
  components: {
    BoListPanel,
  },
})
export default class LockerCompanyLogs extends Vue {
  @lockerCompanyModule.Getter('logs')
  private logs!: ILockerCompanyLog[];

  @lockerCompanyModule.Action('fetchLogs')
  private fetchLogs!: () => ILockerCompanyLog[];

  @lockerCompanyModule.Action('clearLogs')
  private clearLogs!: () => null;

  @lockerCompanyModule.Getter('lockerCompanies')
  private lockerCompanies!: ILockerCompany[]

  protected loading: boolean = false;
  protected expanded: boolean = false;
  protected subscribes: object = {};

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.logs.headers.when'), align: 'start', sortable: false, value: 'created_at' },
      { text: this.$t('lockerCompanies.logs.headers.company'), align: 'start', sortable: false, value: 'locker_company_id' },
      { text: this.$t('common.logs.headers.action'), align: 'start', sortable: false, value: 'action' },
      { text: this.$t('common.logs.headers.data'), align: 'start', sortable: false, value: 'data' },
    ];
  }

  // this is totally wrong. of original solution: what if that company is not loaded yet because of paging? :D
  //  also, when we start deleting this wouldn't work out....
  private companyName(id: number): string {
    const company = this.lockerCompanies.find(each => each.id == id);
    return company ? company.description : `${ id }`;
  }

  private chipText(item: ILockerCompanyLog) {
    if ((item.data as any).s) {
      return (item.data as any).s;
    }
    return item.locker_company_id
      ? '#' + item.locker_company_id
      : '???';
  }

}
